/**
 * Concentric zones from the centre outward. `forest` is the outer starting
 * boundary (mechanically Level 0, like foothills). Everything that scales with
 * elevation — resource bonus, Vigor cost of construction, and Barracks upkeep —
 * is keyed off the vigor zone here.
 */
export const VIGOR_ZONES = [
    "forest",
    "foothill",
    "ridgeline",
    "crag",
    "summit",
];
//# sourceMappingURL=vigor_zones.js.map